// extracted by mini-css-extract-plugin
module.exports = {"head":"LinkBox_head__3AuPM","title":"LinkBox_title__O8lKG","text":"LinkBox_text__3c0rt"};